import { createFileRoute, Link } from '@tanstack/react-router';
import { Tab, Tabs } from '@heroui/react';
import EditSubscriptions from '@/components/nimda/[[...slug]]/Subscriptions';
import FeatureFlags from '@/components/nimda/[[...slug]]/FeatureFlags';
import AdminTeams from '@/components/nimda/[[...slug]]/AdminTeams';
import AdminUsers from '@/components/nimda/[[...slug]]/AdminUsers';

export const Route = createFileRoute('/account/admin/$')({
    component: RouteComponent,
});

function RouteComponent() {
    const { _splat } = Route.useParams();

    return (
        <div className='p-2'>
            <Tabs aria-label='Options' selectedKey={_splat}>
                <Tab
                    as={Link}
                    /* @ts-expect-error tab-link */
                    to='/account/admin/$'
                    params={{ _splat: ['manage_users'] }}
                    key='manage_users'
                    title='Users'>
                    <AdminUsers />
                </Tab>
                <Tab
                    as={Link}
                    /* @ts-expect-error tab-link */
                    to='/account/admin/$'
                    params={{ _splat: ['setup_team'] }}
                    key='setup_team'
                    title='Teams'>
                    <AdminTeams />
                </Tab>
                <Tab
                    as={Link}
                    /* @ts-expect-error tab-link */
                    to='/account/admin/$'
                    params={{ _splat: ['manage_subscriptions'] }}
                    key='manage_subscriptions'
                    title='Manage Subscriptions'>
                    <EditSubscriptions />
                </Tab>
                <Tab
                    as={Link}
                    /* @ts-expect-error tab-link */
                    to='/account/admin/$'
                    params={{ _splat: ['feature_flags'] }}
                    key='feature_flags'
                    title='Feature Flags'>
                    <FeatureFlags />
                </Tab>
            </Tabs>
        </div>
    );
}
